/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/display-name */

import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'

import PIIPopup from '../page-overlay/pii-popup'
import './formvalidation-msgs.css'

interface DueoutFormValidationMsgProps {
  displayPII: any
  inputValidationObj: any
  piiScan: any
  popupCloseOpenFunctionality: any
  ref: any
  setPIIScan: any
  updateClickPosition: 'bottom' | 'top'
  validref: any
}
const DueoutsFormValidationMsgs = forwardRef<HTMLDivElement, DueoutFormValidationMsgProps>(
  (
    {
      displayPII,
      inputValidationObj,
      piiScan,
      popupCloseOpenFunctionality,
      setPIIScan,
      updateClickPosition,
    },
    ref
  ) => {
    const showHideCancel = () => {
      if (updateClickPosition === 'top' || updateClickPosition === 'bottom') {
        popupCloseOpenFunctionality('Close', updateClickPosition)
        setPIIScan({})
      }
    }
    const getInvalidInputs = (validationObj: any) => {
      const keys = Object.keys(validationObj)
      const sortedInputs: any[] = Object.values(validationObj)
        .map((entry: any, index: number) => ({
          ...entry,
          name: keys[index],
        }))
        .sort((a: any, b: any) => a?.order - b?.order)

      return sortedInputs.filter((entry) => !entry.isValid)
    }
    const invalidInputs = getInvalidInputs(inputValidationObj)

    return (
      (invalidInputs.length > 0 || displayPII) && (
        <div
          className='pt-2 validation-msgs mb-3 py-2 ps-2 whitebg shadow text-color5 bordered7 border-radius p-relative'
          ref={ref}
        >
          {displayPII ? (
            <>
              <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />
              <button
                aria-label='Close'
                className='anchorclosebutton py-2 px-2 bgcolor-primary whitetext btn-border-radius3'
                onClick={showHideCancel}
                title='Close'
                type='button'
              >
                <span className='icon-close text-color1 font-10'></span>
              </button>
            </>
          ) : (
            <>
              <h2 className='px-2 title-color1 font-15 sourcesansprosemibold text-uppercase'>
                <span aria-label='Please Fill The Below Mandatory Fields' tabIndex={0}>
                  PLEASE FILL THE BELOW MANDATORY FIELDS
                </span>
              </h2>
              <button
                aria-label='Close'
                className='anchorclosebutton py-2 px-2 bgcolor-primary whitetext btn-border-radius3'
                onClick={showHideCancel}
                title='Close'
                type='button'
              >
                <span className='icon-close text-color1 font-10'></span>
              </button>
              <ul
                aria-live='polite'
                className='marker-color list-type-circle font-13 sourcesanspro'
                tabIndex={0}
              >
                {invalidInputs.map((msgs) => (
                  <li key={msgs.title}>
                    <Link
                      className='links-over-underline'
                      onClick={(e) => {
                        e.preventDefault()
                        if (msgs.title === 'Description') {
                          msgs.link.current.focusEditor()
                        } else if (
                          [
                            'DOS should not less than the current Date',
                            'Due Date should not less than the current Date',
                            'PDD should not less than the current Date',
                            'PRP should not less than the current Date',
                            'RNTD should not less than the current Date',
                          ].includes(msgs.title)
                        ) {
                          msgs.link.current.input.focus()
                        } else {
                          msgs.link.current.focus()
                        }
                      }}
                      title={msgs.title}
                      to=''
                    >
                      {msgs.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )
    )
  }
)
export default DueoutsFormValidationMsgs
